module.exports = __webpack_public_path__ + "static/media/divya-mobile.313dec4a.jpg";